module.exports = __webpack_public_path__ + "static/img/15.789ca26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/15.png
// module id = 2msd
// module chunks = 0